import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <span className="footer__symbol">&#10022;</span>
          <h3 className="footer__name">Maison Dorée</h3>
          <p className="footer__tagline">Where time stops</p>
          <p className="footer__address">
            12 Rue de la Paix<br />
            75002 Paris, France
          </p>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Explorar</h4>
          <Link to="/">Inicio</Link>
          <Link to="/restaurante">Le Jardin</Link>
          <Link to="/reservar">Reservar</Link>
          <Link to="/contacto">Contacto</Link>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Contacto</h4>
          <a href="tel:+34600000000">+34 600 000 000</a>
          <a href="mailto:info@hotelmaison.com">info@hotelmaison.com</a>
          <a href="https://wa.me/34600000000" target="_blank" rel="noopener noreferrer">WhatsApp</a>
        </div>

        <div className="footer__col">
          <h4 className="footer__heading">Legal</h4>
          <span className="footer__muted-link">Aviso legal</span>
          <span className="footer__muted-link">Privacidad</span>
          <span className="footer__muted-link">Cookies</span>
        </div>
      </div>

      <div className="footer__bottom">
        <p>&copy; {new Date().getFullYear()} Hôtel Maison Dorée. Tous droits réservés.</p>
        <p className="footer__demo">Sitio de demostración</p>
      </div>
    </footer>
  );
}
